import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { ContentTypeLogo } from 'src/dashboard/ContentTypeLogo';
import { ImageRenderer } from '../ImageRenderer';
import { Content } from '../interfaces/content.interface';

interface Props {
  src?: string;
  content?: Content;
  renderIcon: (animationClassName: string) => JSX.Element;
  onHover?: () => void;
  className?: string;
  iconWrapperClassName?: string;
  iconContainerClassName?: string;
  hideImageOnHover?: boolean;
}

export const ImageWithHoverableIcon = forwardRef<HTMLDivElement, Props>(
  (
    {
      content,
      iconWrapperClassName = 'rounded-md',
      iconContainerClassName,
      hideImageOnHover = true,
      renderIcon,
      className,
      src,
    },
    ref
  ) => {
    const originClassNames = classNames(
      'bg-bedrock-black-overlay transition-opacity duration-200 opacity-100',
      {
        'group-hover:opacity-0': hideImageOnHover,
      },
      className
    );

    return (
      <>
        {content ? (
          <ContentTypeLogo
            destination={content.embed?.destination}
            externalLinkUrl={content.external_link?.url}
            contentType={content.content_type}
            className={originClassNames}
          />
        ) : (
          <>{src && <ImageRenderer src={src} className={classNames(originClassNames, 'w-10 h-10')} />}</>
        )}
        <div
          onClick={(event) => {
            event.stopPropagation();
          }}
          className={classNames('absolute flex justify-center left-0 top-0 h-full z-30', iconContainerClassName)}
        >
          <div
            ref={ref}
            className={classNames(
              'w-10 h-10 opacity-0 cursor-pointer transition-opacity duration-200 bg-bedrock-black/backdrop backdrop-blur group-hover:opacity-100',
              iconWrapperClassName
            )}
          >
            {renderIcon('transition-transform hoverable-icon group-hover:hoverable-icon--hover')}
          </div>
        </div>
      </>
    );
  }
);
